<template>
  <div class="cell-content" :align="isOnMobile ? 'right' : ''" style="min-width: 85px">
    <span class="primary-text">{{ customDateFormat(voicemail.time) }}</span>
    <span class="sub-text">{{ formatDuration(voicemail.duration) }}</span>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { format, formatDistanceToNow, isWithinInterval, subWeeks, intervalToDuration } from 'date-fns'
import { enUS, enAU, enGB, frCA } from 'date-fns/locale'

export default {
  name: 'voicemail-msgs-table-origtime-column',
  props: {
    voicemail: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(['summaryEnabled']),
    dateFnsLangMap () {
      return {
        'en-US': enUS,
        'en-GB': enGB,
        'en-AU': enAU,
        'fr-CA': frCA
      }[this.$i18n.locale]
    },
    isOnMobile () {
      return this.$vuetify.breakpoint.mobile
    }
  },
  methods: {
    customDateFormat (date) {
      const dateObj = new Date(date)
      const locale = this.dateFnsLangMap
      if (isWithinInterval(dateObj, { start: subWeeks(new Date(), 1), end: new Date() })) {
        return formatDistanceToNow(dateObj, { addSuffix: true, locale })
      }
      if (dateObj.getFullYear() === new Date().getFullYear()) {
        return format(dateObj, 'MMM d', { locale })
      }
      return format(dateObj, 'MMM d, yyyy', { locale })
    },
    formatDuration (seconds) {
      const duration = intervalToDuration({ start: 0, end: seconds * 1000 })

      const parts = []
      if (duration.hours) {
        parts.push(`${duration.hours}h`)
      }
      if (duration.minutes) {
        parts.push(`${duration.minutes}m`)
      }
      if (duration.seconds || parts.length === 0) {
        parts.push(`${duration.seconds}s`)
      }

      return parts.join(' ')
    }
  }
}
</script>

<style scoped>
</style>
